module.exports = __webpack_public_path__ + "img/c05_unittechonagerchampion_Normal_ua.2f3c29c2.webp";